import Header from "@/components/Header";
import Footer from "@/components/Footer";

const GROUPS = [
  ["Project Leadership", ["Founder — Ramon Pasos"]],
  ["Research Team", ["California Rental Experience Project Research Team"]],
  ["Advisory Board", ["To be announced"]],
  ["Contributors", ["Researchers", "Data analysts", "Volunteer reviewers", "Housing professionals"]],
];

export default function AboutProjectPage() {
  const year = new Date().getFullYear();
  return (
    <div className="min-h-screen bg-white font-body text-ink">
      <Header />

      <section className="mx-auto max-w-7xl px-6 pb-12 pt-20 md:px-12 md:pt-28">
        <div className="text-xs uppercase tracking-[0.2em] text-calblue">About the Project</div>
        <h1 className="mt-4 max-w-3xl font-serif text-5xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
          An independent housing research initiative.
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-700">
          The California Rental Experience Project was founded by Ramon Pasos in 2026 to build a
          transparent, nonpartisan record of how rental housing is advertised and experienced
          across California. Reports are published under the organization so that many people can
          contribute over time without changing how the work is cited.
        </p>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-16 md:px-12">
        <div className="grid gap-px bg-slate-200 sm:grid-cols-2">
          {GROUPS.map(([title, people]) => (
            <div key={title} data-testid={`about-group-${title.toLowerCase().replace(/\s+/g, "-")}`} className="bg-white p-8">
              <div className="text-xs uppercase tracking-[0.2em] text-calblue">{title}</div>
              <ul className="mt-4 space-y-2">
                {people.map((p) => (
                  <li key={p} className="text-slate-700">{p}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-32 md:px-12">
        <div className="border border-calblue/40 bg-slate-50 p-8" data-testid="about-citation">
          <div className="text-xs uppercase tracking-[0.2em] text-calblue">
            How to cite our work
          </div>
          <p className="mt-4 leading-relaxed text-slate-700">
            California Rental Experience Project. ({year}). California Rental Screening Report{" "}
            {year} (Version 1.0). California Rental Experience Project.
          </p>
          <p className="mt-4 text-sm text-slate-500">
            © {year} California Rental Experience Project. All Rights Reserved.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
